export enum WidgetPlatformEnum {
    Widget = 'widget',
    WidgetAPI = 'widgetapi'
}
